import template from './templates/template-text.hbs';
import DesignFacade from '../../../../facade/design/design';

module.exports = Backbone.View.extend({
  addTextEvent: function (event) {
    const $el = $(event.currentTarget);
    DesignFacade.create('text', this.getClickElementData($el));
  },

  initialize: function () {
    _.bindAll(this, 'render');
    this.editor = INKIVE.Tool.getInstance().editor;
    this.$el.closest('a').one('mousedown', this.render);
  },

  render: function () {
    const sizes = [50, 35, 20, 15];
    const data = INKIVE.C.TextDefault.map((defaultText, i) => ({
      ...defaultText,
      textContent: defaultText.text,
      fontSize: sizes[i]
    }));
    this.$el.html(template(data));

    this.$el.find('.text-tool').on('click', _.bind(this.addTextEvent, this));
  },

  getClickElementData: function ($element) {
    const offset = this.editor.getOffset();
    const baseData = this.getBaseElementData($element);
    const x = (offset.width - baseData.size.width) / 2;

    return _.extend(baseData, {
      position: {
        x: Math.floor4(x),
        y: Math.floor4((offset.height - baseData.font.size) / 2)
      }
    });
  },

  getQuoteScaped: function (fontFamily) {
    return fontFamily.replace(/^['|"](.*)['|"]$/, function (initial, data) {
      return data;
    });
  },

  getBaseElementData: function ($element) {
    const canvas = this.editor.canvas;
    const baseSize = _.min([canvas.contentW, canvas.contentH]);
    const containerWidth = $element[0].getBoundingClientRect().width;
    const fontSize = Math.round(baseSize * $element.data('size'));
    let textContent = $element.text().trim();
    let width = containerWidth * (fontSize / 25);
    const textBlock = $element.find('span').html();

    if (textBlock) {
      width = parseInt($('#svgcontent').attr('width')) / 2;
      textContent = textBlock;
    }

    return {
      selected: true,
      content: textContent,
      font: { size: fontSize, family: this.getQuoteScaped($element.css('font-family')) },
      size: { width: Math.floor4(width) }
    };
  }
});
